import { render, staticRenderFns } from "./IconAlertCircle.vue?vue&type=template&id=7672e2a8"
import script from "./IconAlertCircle.vue?vue&type=script&lang=js"
export * from "./IconAlertCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports